import React, { useRef} from 'react';
import './Cards.css';
import { useNavigate, Link } from 'react-router-dom';
import { cat_fibtexFromServer, getBauMitigacion, getMeasures, 
        getReducciones, getResults, getYears, colRefMeasures } from '../firebase';
import { Modal1 } from './Modal1';
import { MedirTransporteTerrestre } from '../components/MedirTransporteTerrestre';
import { MedirTransporteAereo } from '../components/MedirTransporteAereo';
import { MedirTransporteMaritimo } from '../components/MedirTransporteMaritimo';
import { MedirEnergiaElectrica } from '../components/MedirEnergiaElectrica';

import EditTable from '../EditTable';
import { LineReduccion } from '../components/LineReduccion';
import domtoimage from 'dom-to-image';
import { useReactToPrint } from 'react-to-print'
import ChartPie from '../components/ChartPie';
import { Refresh } from '@material-ui/icons';

let totalTTmateriaPrima = 0;
let totalTTtrabajo = 0;
let totalAereo = 0;
let totalMaritimo = 0;
let totalEnergia = 0;
let bauTotal = 0;
let yearMeasure = 2019;

let bauMitigacionExterno = [];
let datosBauExterno = [];
let reduccionesExterno = [];
let bauReal = [];

let imgDona = null;
let dataPie = null;

function Home( props ) {
  React.useEffect(()=>{
    
    document.getElementsByClassName('navbar')[0].style.display = 'flex';
  },[])


    const subcategorias = [
      {id: 2,formula:'distancia_km*peso_ton*591/1000', fe:591, nombre: "Transporte terrestre",},
      {id: 3,formula_carga:'distancia_km*peso_ton*1.32', formula_nacional:'distancia_km*numero_recorridos*175.3/1000',formula_internacional:'Kilometros*aereo_cantidad_recorridos*110.6/1000', fe_nacional:175.3, fe_internacional:110.6, fe_carga:1.32, nombre: "Transporte aéreo"},
      {id: 4,formula:'distancia_km*peso_ton*6/1000', fe:6,   nombre: "Transporte marítima"},
      {id: 6, fe:0.225, formula:'0.225*consumo_energia_anual_mwh', nombre: "Consumo de energía eléctrica", formula_factura:"kilovatio_hora * 0.203", fe_factura: "0,203"}
      
    ]
    
    const [measures, setMeasures] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [isLoadingEntrada, setIsLoadingEntrada] = React.useState(false);
    const [dataSubcat, setDataSubcat] = React.useState([]);
    const [dataSubcategorias, setDataSubcategorias] = React.useState([]);
    const [carbonoTotal, setCarbonoTotal] = React.useState(0);
    const [selected, setSelected] = React.useState(0);
    const [hovered, setHovered] = React.useState(undefined);
    const [buscarAlcance, setBuscarAlcance] = React.useState(1);
    const [actualizarPie, setActualizarPie] = React.useState(1);
    const [openModal, setOpenModal] = React.useState(false);
    const [yearHuella, setYearHuella] = React.useState(2019);
    const [dataTable, setDataTable] = React.useState([])

    const [bauYears, setBauYears] = React.useState([])
    const [loadingYears, setLoadingYears] = React.useState(true);

    const [datosBau, setDatosBau] = React.useState([])
    const [isReduccion, setIsReduccion] = React.useState(false);

    const [reducciones, setReducciones] = React.useState(null)
    const [loadingReducciones, setLoadingReducciones] = React.useState(true);

    const [bauMitigacion, setBauMitigacion] = React.useState(null);
    const [LoadingBauMitigacion, setLoadingBauMitigacion] = React.useState(true);

    const handleYearHuella = (event) =>{
      yearMeasure = Number(event.target.value);
      setYearHuella(Number(event.target.value));
    }

    /*let totalTTmateriaPrima= 0;
    let totalTTtrabajo= 0;
    let totalAereo= 0;
    let totalMaritimo= 0;
    let totalEnergia= 0;*/
    let tableD = [];
    let oldDatosBau = []
  
    React.useEffect(() => {
      getMeasuresFromServer(yearHuella, true);
      setDataTable(tableD);
      renderTable(yearHuella);
      console.log('Actualizando getMeasuresFormServer === '+ yearHuella)
    },[yearHuella]);
    
    React.useEffect(() => {
      getYearsFromServer();
      //console.log('Actualizando getYearsFormServer')
    },[])
    React.useEffect(() => {
      getBauMitigacionFromServer();
      //console.log('Actualizando getBauMitigacionFormServer')
    },[])

    React.useEffect(() => {

      getReduccionesFromServer();
      //console.log('Actualizando getReduccionesFormServer')
    }, [])

    const getBauMitigacionFromServer = async () => {
      setLoadingBauMitigacion(true)
      let bauMitigacionServer = [];
      await getBauMitigacion()
      .then((snapshot) => {
        ////console.log(snapshot)
        snapshot.docs.forEach((doc) => {
          bauMitigacionServer.push({ ...doc.data(), id: doc.id})
        })
        if (bauMitigacionServer !== null || bauMitigacionServer !== undefined || bauMitigacionServer !== false) {
          setBauMitigacion(bauMitigacionServer);
          bauMitigacionExterno = bauMitigacionServer;
          //console.log('Enviando bauMitigacionExterno')
          //console.log(bauMitigacionExterno)
        }
        ////console.log(reducciones)
      })
      setLoadingReducciones(false)
    }

    const getReduccionesFromServer = async () => {
      setLoadingReducciones(true)
      let reduccionesServer = [];

      await getReducciones()
      .then((snapshot) => {
        ////console.log(snapshot)
        snapshot.docs.forEach((doc) => {
          reduccionesServer.push({ ...doc.data(), id: doc.id})
        })
        if (reduccionesServer !== null || reduccionesServer !== undefined || reduccionesServer !== false) {
          setReducciones(reduccionesServer);
          reduccionesExterno = reduccionesServer;
          //console.log('Enviando reduccionesExterno')
          //console.log(reduccionesExterno)
        }
        ////console.log(reducciones)
      })
      setLoadingReducciones(false)
    }

    const getYearsFromServer = async ()=> {
      bauReal = [];
      setLoadingYears(true);
      let years = []
      let yearsReduccion = [];
      await getYears()
      .then((snapshot) => {
          snapshot.docs.forEach((doc) => {
              years.push({ ...doc.data(), id: doc.id })
          })
          if (years !== null || years !== undefined || years !== false) {
            const yearsRed = years[0].years;
            yearsRed.forEach(element => {
              yearsReduccion.push({id:element, year: element});
            }); 
          }
      })
      setBauYears(yearsReduccion);
      setLoadingYears(false);
      buildLineChart(yearsReduccion);
    }

    //Descarga datos desde Base datos Firebase para el gráfico
    const getMeasuresFromServer = async (yearQuery, entrar) => {
      await getMeasures(yearQuery)
      //const getMeasuresFromServer = async => {
      //fetch('https://www.serviciosynavegacion.com/usr_bd/entradas_fibtex.json')
            //.then(response => response.json())
            .then( snapshot => {
              setIsLoading(true);
              
              ////console.log(snapshot);
              let measuresServer = [];
              
              snapshot.docs.forEach((doc) => {
                measuresServer.push({ ...doc.data(), id: doc.id });
              })
              //console.log(JSON.stringify(measuresServer, null,2));
              let numberMax = '0123456789ABCDEFGH'
              /*snapshot.forEach(doc => {
                measuresServer.push({ ...doc, id: Math.floor(Math.random() * 9999999 ).toString(16)})
              })*/
              
              let totalTTmateriaPrimaYear = 0;
              let totalTTtrabajoYear = 0;
              let totalAereoYear = 0;
              let totalMaritimoYear = 0;
              let totalEnergiaYear = 0;
              let bauTotalYear = 0;
              let totalResultado = 0;

              measuresServer.map(measure => {
                  
                  let resultado = Number(measure.resultado_kgco2);
                  
                  if (resultado === undefined ) { resultado = 0; console.log('********resultado == '+ Number(measure.resultado_kgco2));}
                  if ( isNaN(resultado) ) { resultado = 0; console.log('********resultado == '+ Number(measure.resultado_kgco2));}
                  
                  totalResultado = totalResultado + measure.resultado_kgco2;
                  let subcat = measure.subcategoria;
                  let distancia = measure.distancia_km;
                  let trayecto = measure.origen +' - '+ measure.destino;
                  let usuario = measure.user;
                  let fecha = measure.fecha_modificacion;
                  let year = measure.year;

                  let pasajeros = measure.numero_viajeros;
                  if (subcat !== undefined) {
                    subcat = (measure.subcategoria).replace('Transporte','')
                  }
                  let referencia = measure.referencia_producto;

                  if (measure.subcategoria === 'Consumo de energía eléctrica') {
                    totalEnergiaYear =  totalEnergiaYear + resultado;
                    //console.log('totalEnergiaYear ='+totalEnergiaYear)
                    //console.log('resultado ='+resultado)
                    let nombre_dispositivo = measure.nombre_dispositivo;
                    if (nombre_dispositivo === undefined) { nombre_dispositivo = ""; }
                    let referencia_producto = measure.referencia_producto;
                    if (referencia_producto === undefined) { referencia_producto = ""; }
                    referencia = nombre_dispositivo + " - " +referencia_producto ;
                    distancia = measure.consumo_energia_anual_kwh;
                    trayecto = measure.nombre;
                  }
                  if (measure.subcategoria === 'Transporte aéreo') {
                    
                    totalAereoYear = totalAereoYear + resultado;
                    
                    if (pasajeros != undefined) {
                      referencia += " " + pasajeros + " pasajero";
                    }
                    
                  }
                  if ( (measure.subcategoria === 'Transporte marítimo') || (measure.subcategoria === 'Transporte marítima')) {
                    totalMaritimoYear = totalMaritimoYear + resultado;
                    //console.log('totalMaritimoYear ='+totalMaritimoYear)
                  }
                  if (measure.subcategoria === 'Transporte terrestre') {
                    if (((measure.nombre === 'Transporte materia prima') 
                        || (measure.nombre === 'Transporte producto final')
                        || (measure.nombre === 'Transporte reciclaje'))) {
                      totalTTmateriaPrimaYear = totalTTmateriaPrimaYear + resultado;
                    }
                    if (measure.nombre === 'Transporte trabajo') {
                      totalTTtrabajoYear = totalTTtrabajoYear + resultado;
                    }
                  }
                  

                  if (resultado !== null) {resultado = ((resultado).toFixed(3)).toString();}
                    const nuevoTableRegistro = {
                      id: measure.id,
                      alcance: measure.alcance,
                      categoria: measure.categoria,
                      subcategoria: subcat,
                      nombre: measure.nombre,
                      trayecto: trayecto,
                      referencia: referencia,
                      fe: measure.fe,
                      vehiculo: measure.tipo_vehiculo,
                      distancia: distancia,
                      pasajeros: pasajeros,
                      peso: measure.peso_ton,
                      resultado: Number(resultado),
                      usuario: usuario,
                      fecha: fecha,
                      year: year
                    }
                    // if ((Number(yearQuery) === 2021) && ( Number(distancia) === 177)) {
                    //   console.log(JSON.stringify(nuevoTableRegistro,null, 2));
                      
                    // }
                    //console.log('Factor FE'+measure.fe)
                    tableD.push(nuevoTableRegistro);
                  //}
              })
              
              let numberCarbonoYear = (totalTTmateriaPrimaYear + totalTTtrabajoYear + totalAereoYear + totalMaritimoYear + totalEnergiaYear);
              console.log(totalTTmateriaPrimaYear +' - '+ totalTTtrabajoYear +' - '+ totalAereoYear +' - '+ totalMaritimoYear +' - '+ totalEnergiaYear)
              //console.log('carbonoYear = '+numberCarbonoYear);
              const newData = {
                totalTTmateriaPrima: totalTTmateriaPrimaYear.toFixed(3),
                totalTTtrabajo: totalTTtrabajoYear.toFixed(3),
                totalAereo: totalAereoYear.toFixed(3),
                totalMaritimo: totalMaritimoYear.toFixed(3),
                totalEnergia: totalEnergiaYear.toFixed(3),
                bauTotal: numberCarbonoYear.toFixed(3),
                year: yearQuery
              }
              bauReal.push({
                year: yearQuery,
                bauTotal: numberCarbonoYear
              });
              
              const indexYear = datosBau.findIndex(v => (v.year === yearQuery ));
              ////console.log('INDEX YEAR == '+indexYear)
              const dataYear = [ ...datosBau ]
              if (indexYear > -1) {
                
                dataYear.splice(indexYear, 1);
                dataYear.push(newData)
                oldDatosBau = newData;
                setDatosBau(dataYear);
                datosBauExterno = dataYear;
                //console.log('Enviando datosBauExterno')
                //console.log(datosBauExterno)
              }else{
                oldDatosBau.push(newData)
                setDatosBau(oldDatosBau);
                datosBauExterno = oldDatosBau;  
                //console.log(datosBauExterno)
              }

              if (entrar === true) {
                setMeasures(measuresServer);
                //console.log('Abriendo Primer cargue de datos.......'+yearQuery)
                
                totalTTmateriaPrima = Number(totalTTmateriaPrimaYear.toFixed(3));
                totalTTtrabajo = Number(totalTTtrabajoYear.toFixed(3));
                totalAereo = Number(totalAereoYear.toFixed(3));
                totalMaritimo = Number(totalMaritimoYear.toFixed(3));
                totalEnergia = Number(totalEnergiaYear.toFixed(3));
                bauTotal = numberCarbonoYear;

                //bauTotalYear = (new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2}).format(numberCarbonoYear));

                const datosSubcats = [{
                  key: 1,
                  color: "#89CFF0",
                  title: 'T.T. materia prima',
                  value: totalTTmateriaPrima
                },{
                  key: 2,
                  color: "#1F8DE8",
                  title: 'T.T. trabajo',
                  value: totalTTtrabajo
                },{
                  key: 3,
                  color: "#3AE8CD",
                  title: 'T. Aéreo',
                  value: totalAereo
                },{
                  key: 4,
                  color: "#0096FF",
                  title: 'T. Marítimo',
                  value: totalMaritimo
                },{
                  key: 5,
                  color: "#40FE9D",
                  title: 'Consumo energía',
                  value: totalEnergia
                }]

                setDataSubcategorias(datosSubcats);
                dataPie = datosSubcats;
                setDataSubcat(datosSubcats);
                setCarbonoTotal((new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2}).format(bauTotal)));
                setDataTable(tableD);
                //renderTable(yearHuella);
                
                //console.log('Cerando Primer cargue de datos.......'+yearQuery)
              }
              //console.log('TotalResultado = '+totalResultado);
              setIsLoading(false);
              ////console.log( yearQuery +' -- '+ totalTTmateriaPrimaYear +' -- '+ totalTTtrabajoYear +' -- '+  totalAereoYear +' -- '+ totalMaritimoYear +' -- '+ totalEnergiaYear );

          })
          
         
    }

  // Recibe el llamado del hijo EditTable para recargar datos en la gráfica
  const handleCallback=(childData)=>{
    ////console.log('respuesta del hijo'+JSON.stringify(childData));
    if (childData) {
      getMeasuresFromServer(yearHuella, true);
    }else{
      if (childData) {
        ////console.log('respuesta desde Firebase chilDAta'+JSON.stringify(childData));
      }else{
        ////console.log(childData)
      }
    }
  }

  //Hacer render del Material table la primera vez.
  const renderTable = (yearHuella) => {
    return <EditTable parentCallback={handleCallback} year={yearHuella} data={dataTable} user={props.user}></EditTable>
  }

  // Actualiza Gráfica según selecciona Alcances o Categorías.
  //render los textos de categorias o alcances de la lista de la gráfica
  function renderRows() {
    const listItems = data.map((obj) =>
     <li key={obj.key} style={{color:obj.color,width:'120%'}} className='li__chart'>{obj.title}</li>
    );
    return <ul style={{ listStyleType:'none'}}>{listItems}</ul>
  }

  // cambio el color a magenta cuando pasa por encima del gráfico
  const data = dataSubcat.map((entry, i) => {
    if (hovered === i) {
      return {
        ...entry,
        color: 'magenta',
        title: entry.title +': '+ entry.value
      };
    }
    return entry;
  });

  const onChangeActualizarPie = (event) => {
    setActualizarPie(event.target.value);
    if (event.target.value === "1") {
      setDataSubcat(dataSubcategorias);
    }else{
      
      //console.log('actualizarPie: '+event.target.value);
      let alcance1 = 0;
      let alcance2 = 0;
      let alcance3 = 0;
      let totalMesures = 0;
      measures.map(measure => {
        totalMesures = totalMesures + Number(measure.resultado_kgco2);
        //console.log('measure == '+ JSON.stringify(measure));
        if (measure.alcance === 1) { (alcance1 = alcance1 + measure.resultado_kgco2).toFixed(3)};
        if (measure.alcance === 2) { (alcance2 = alcance2 + measure.resultado_kgco2).toFixed(3)};
        if (measure.alcance === 3) { (alcance3 = alcance3 + measure.resultado_kgco2).toFixed(3)};
        
      })
      //console.log('Alc 1= '+alcance1+', Alc 2= '+alcance2+', Alc 3 = '+alcance3);
      //console.log('totalMesures = '+totalMesures)
      const datosSubcats = [{
        key: 1,
        color: "#1B29D0",
        title: 'Alcance 1',
        value: alcance1
      },{
        key: 2,
        color: "#1F8DE8",
        title: 'Alcance 2',
        value: alcance2
      },{
        key: 3,
        color: "#3AE8CD",
        title: 'Alcance 3',
        value: alcance3
      }]
      setDataSubcat(datosSubcats); 
    }
  }

  const onClickPie = (e) => {
    ////console.log('click'+e);
  }

  let navigate = useNavigate();
  const linkMedicion = () => {
    //window.location.href='/categorias';  
  }

  const optionsSelectAlcances = [
    { value: "Alcance1", label: "Alcance 1" },
    { value: "Alcance2", label: "Alcance 2" },
    { value: "Alcance3", label: "Alcance 3" }
  ];

  // Administración del Modal
    // Abre el modal con las subcategorias para insertar nuevas entradas//
    const agregarEntrada =() => {
      //console.log(yearHuella)
      document.getElementById('cards').style.filter = 'blur(5px)';
      //setForm__Measure(<MedirTransporteTerrestre user={props.user} sub={sub} year={yearHuella}></MedirTransporteTerrestre>);
      setOpenModal(true);
    }
    const onClickCerrarModal=()=> {
      document.getElementById('cards').style.filter = 'blur(0px)';
      setOpenModal(false);
      
      //se envía a refrescar datos en tabla y gráfico
      getMeasuresFromServer(yearHuella, true);
    }
    // Variables del sub para enviar al render de la entrada cuando se cambia
    // la categoria en el select //
    const [sub, setSub] = React.useState({id: 2,
      formula:'distancia_km*peso_ton*591/1000',
      nombre: "Transporte terrestre",
      fe:591, 
      fe_camion_turbo:591,
      fe_camion_pesado:336,
      fe_automovil:160,
      fe_tractomula:163,
      fe_bus:1.0779692670133, 
      fe_tren:1.0779692670133,
    });
    const [form__Measure, setForm__Measure] = React.useState(<MedirTransporteTerrestre user={props.user} sub={sub} year={yearHuella}></MedirTransporteTerrestre>)
    const cat_fibtex = cat_fibtexFromServer;
    
    const renderEntradaSubcategoria = (event) => {
      setBuscarAlcance(event.target.value);
      ////console.log('cambiando el formulario de medida '+event.target.value);
      
      let sub = {
        id: 2,
        formula:'distancia_km*peso_ton*591/1000',
        nombre: "Transporte terrestre",
        fe:591, 
        fe_camion_turbo:591,
        fe_camion_pesado:336,
        fe_automovil:160,
        fe_tractomula:163,
        fe_bus:1.0779692670133, 
        fe_tren:1.0779692670133,
      };
      if (event.target.value === "Transporte terrestre") {
        setForm__Measure(<MedirTransporteTerrestre user={props.user} sub={sub} year={yearHuella}></MedirTransporteTerrestre>);
      }else if (event.target.value === "Transporte aéreo") {
      
        sub =  {
          id: 3,
          nombre: "Transporte aéreo",
          formula_carga:'distancia_km*peso_ton*1.32', 
          formula_nacional:'distancia_km*numero_recorridos*175.3/1000',
          formula_internacional:'Kilometros*aereo_cantidad_recorridos*110.6/1000', 
          fe_nacional:175.3, 
          fe_internacional:110.6,


          fe_carga_nacional:2.48,
          fe_carga_corto:1.03,
          fe_carga_largo:0.65,

          fe_pasajeros_nacional:124.8,
          fe_pasajeros_corto:77.5,
          fe_pasajeros_largo:95.8,

          fe_carga:1.32 };
        setForm__Measure(<MedirTransporteAereo user={props.user} sub={sub} year={yearHuella}></MedirTransporteAereo>);
      }else if (event.target.value === "Transporte marítima") {
        sub = {id: 4,formula:'distancia_km*peso_ton*6/1000', fe:'6',   nombre: "Transporte marítima"};
        setForm__Measure(<MedirTransporteMaritimo user={props.user} sub={sub} year={yearHuella}></MedirTransporteMaritimo>);
      }else if (event.target.value === "Consumo de energía eléctrica") {
      
        sub = {id: 6, fe:'0.225', formula:'0.225*consumo_energia_anual_mwh', nombre: "Consumo de energía eléctrica", formula_factura:"kilovatio_hora * 0.203", fe_factura: "0.203"};
        setForm__Measure(<MedirEnergiaElectrica user={props.user} sub={sub} year={yearHuella}></MedirEnergiaElectrica>);
      }
    }
  /// hasta aquí va administración del Modal

  // Abre formulario de añadir nuevo registro de reducción.
  const subSel = [{id: 9, nombre: "Reducción huella de CO2"}];
  
  //Consultar los datos de measures año por año y envia a Reduccion para generar la linea del gráfico por años
  const buildLineChart = (years) => {
    ////console.log('Imprimiendo los años de reduccion si lo hay')
    
    years.map((y) => {
      if (y.year !== 2019) {
        //console.log('LLamando measures del año = '+y.year);
        getMeasuresFromServer(y.year, false);
      }
    })
    setIsReduccion(true);
  }

  const renderLineReduccion = () => {
  /*  const datoYears = [];
    const datoBau = [];
    const datoMitigacion = [];
    //console.log(reducciones);
    datosBau.map((bau) => { 
      let bauMiti = 0;
      if (reducciones !== null) {
        reducciones.map((red) => {
          bauMiti = 0;
          if (red.year_inicio < bau.year < red.year_final) {
            bauMiti = 0;
            Object.entries(bau).map(([key, value]) => {
              if ((key !== 'bauTotal') && (key !== 'year')) {
                ////console.log('esta en el rango '+key+' -- value='+value);
                if (key === 'total'+red.code){
                  const valor = value * (100 - Number(red.porcentaje_reduccion))/100;
                  ////console.log(valor);
                  bauMiti += valor;
                }else{
                  bauMiti += value;
                }
              }
              ////console.log(bauMiti)
            })
          }
        });
        //console.log('bauMiti= '+bauMiti+' -- year= '+bau.year);
        datoYears.push(bau.year);
        datoBau.push( parseFloat(bau.bauTotal).toFixed(2));
        datoMitigacion.push( parseFloat(bauMiti).toFixed(2));
      }
    })*/
  //return <LineReduccion years={datoYears} bau={datoBau} mitigacion={datoMitigacion}></LineReduccion>
    return <div>
          <div style={{textAlign:'Center'}}>
            <img src='/icon-reduction.svg'></img>
            <span>Reducción en el tiempo (Kg CO<sub>2</sub>eq)</span>
          </div>
            <LineReduccion ></LineReduccion>
        </div>
  }

  /*const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });*/

  const toPng = () => {
    var node = document.getElementById('pieChart')
    domtoimage.toPng(node)
    .then ( function (dataImg) {
      var img = new Image();
      img.src = dataImg;
      //document.body.appendChild(img);

      imgDona = dataImg;
      ////console.log(dataImg);
    }).catch(function (error) {
      //console.log('Algo salio mal')
    });
  }

  return (
    <>
    <div>
      {!!openModal && (
        <Modal1 open={openModal}>
        <div>
        <h2 >Seleccione la subcategoría que desea ingresar</h2>
          <select className='select__modal' value={buscarAlcance} onChange={renderEntradaSubcategoria}>
            {
              subcategorias.map(subs => (
                <option value={subs.nombre} key={subs.id}>{subs.nombre}</option>
              ))
            }
          </select>
        </div>
          {!isLoadingEntrada && form__Measure}
          <button className='boton__cerrar__modal' onClick={onClickCerrarModal}></button>
        </Modal1>
      )}
    </div>
    
    <div id='cards' className='cards'>
      {/* <div id='cards' className='cards' ref={componentRef}>
      <button style={{ height:'50px',width:'50px',position:'relative',top:'100px'}} onClick={() => toPng()}>Print to pdf
      </button>*/}
      <h1 style={{ position:'relative',right:'10%', top:'20px', color:'#0B149D'}}>Medición de tu huella de carbono.</h1>
      { !loadingYears &&
        <select id='selectNombre' className='year__huella'  
            value={yearHuella} 
            onChange={handleYearHuella}>
            { bauYears.map((y) => {
                return <option key={y.year} value={y.year}>{y.year}</option>
              })
            }
        </select>
      }

      {/*<Link className="nueva__huella__btn font__family" to="/categorias">Añade un nuevo año</Link>*/}
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
         
            <li id='pieChart' onClick={ linkMedicion } className='cards__item' style={{boxShadow:' 0 6px 20px rgb(56 125 255 / 17%)',
              filter:' drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017))'}}>
              <h3 style={{ position: 'absolute',fontSize:'medium',color:'royalblue',padding:'0px',left:'26px'}}>
                Tu huella de carbono (Kg CO<sub>2</sub>eq)
              </h3>
              {
                <ul style={{ position:'relative',top:'14%',listStyle:'none',left:'-54px',fontSize:'14px'}}>
                  { renderRows() }
                </ul>
              }
              <div className="chart-container">
                <label style={{position:'absolute',left:'52%',top:'48%',fontFamily:'Source Sans Pro',fontSize:'22px',fontWeight:'600',color:'#003366'}}>{carbonoTotal}</label>
                <label style={{position:'absolute',left:'53%',top:'55%',fontFamily:'Source Sans Pro',fontSize:'16px',fontWeight:'600',color:'#8A8888'}}>Kg CO<sub>2</sub>eq BAU</label>
                
                <ChartPie 
                  data={data} 
                  onMouseOver={(_, index) => {
                    setHovered(index);
                  }}
                  onMouseOut={() => {
                    setHovered(undefined);
                  }}>
                </ChartPie>
                {
                  
                  /*<PieChart 
                      animate
                      animationDuration={500}
                      animationEasing="ease-out"
                      center={[50, 50]}
                      data={data}
                      label={ ({ dataEntry }) => Math.round(dataEntry.percentage) +'%' }
                      labelPosition={65}
                      labelStyle={{
                        fontSize: "6px",
                        fontColor: "FFFFFA",
                        fontWeight: "800",
                      }}
                      lengthAngle={360}
                      lineWidth={50}
                      paddingAngle={0}
                      radius={50}
                      onClick={ (event, index) => {
                        setSelected(index === selected ? undefined : index);
                      } }
                      onMouseOver={(_, index) => {
                        setHovered(index);
                      }}
                      onMouseOut={() => {
                        setHovered(undefined);
                      }}
                      startAngle={0}
                      viewBoxSize={[100, 100]}
                />*/}

              </div>
                <select style={{position:'absolute',padding:'7px',top:'86%',marginLeft:'5px',borderRadius:'8px',color:'#0B149D',fontFamily:'Source Sans Pro',fontSize:'18px',fontWeight:'600'}} 
                        value={actualizarPie} 
                        onChange={onChangeActualizarPie}>
                  <option value="1">Categorías</option>
                  <option value="2">Alcances</option>
                </select>
            </li>
            <li className='cards__item' style={{boxShadow:' 0 6px 20px rgb(56 125 255 / 17%)',
              filter:' drop-shadow(0 6px 20px rgba(56, 125, 255, 0.017))'}}>

            <div className='cards__item__link'>
              { (!isReduccion && !reducciones === null) ?
                <div>
                  <figure className='cards__item__pic-wrap'>
                    <img className='cards__item__img' src='reduccion_carbono.png'></img>
                  </figure>
                  <div className='cards__item__info'>
                    <h4 style={{color:'#0B149D',fontFamily:'Source Sans Pro',fontSize:'24px',fontWeight:'600'}} className='cards__item__text'>Reducción en el tiempo</h4>
                    <h5 style={{color:'#0B149D',fontFamily:'Source Sans Pro',fontSize:'16px'}}>Debes completar tus metas de reducción de carbono, para poder ver las proyecciones</h5>
                  {<div>
                        <Link to='/entradas' className='boton__continua' state={ {subSel} } >AÑADIR 
                        </Link>
                  </div>
                  }
                  </div>
                </div>
              :
                renderLineReduccion()
              }
            </div>
            </li>
          </ul>
          <ul className='cards__items'>
            <div style={{ width:'100%'}}>
              <div>
              {/*
                <button id='boton_alcance' onClick={() => onClickAlcances()} style={{ textDecoration:'underline',color:'#0B149D',paddingBottom:'15px', marginLeft:'38%', border:'none',background:'transparent' }}>Alcances</button>
                <button id='boton_categoria' onClick={() => onClickCategorias()} style={{ textDecoration:'underline',color:'#0B149D30',marginLeft:'10%', border:'none',background:'transparent' }}>Categorías</button>
                <br/>
                */}
                  <div className="form-group">
                    <label>
                    { 
                      /*renderAlcanceCategoria() */
                    }
                    {/*<select style={{padding:'7px',marginBottom:'12px',marginLeft:'5px',borderRadius:'8px',color:'#0B149D',fontFamily:'Source Sans Pro',fontSize:'18px',fontWeight:'600'}} value={buscarAlcance} onChange={onChangeBuscarAlcance}>
                      <option value="1">Alcance 1</option>
                      <option value="2">Alcance 2</option>
                      <option value="3">Alcance 3</option>
                    </select>*/}
                    </label>
                    <button id='boton_nueva_entrada' onClick={() => agregarEntrada()} className='boton__nueva__entrada'>Nueva entrada</button>
                    {/*<div>
                        <Link to='/reporte' className='boton__continua' >Reporte 
                        </Link>
                    </div>*/}
                  </div>
                
              </div>
              { !isLoading ?
                renderTable(yearHuella)
                : <img src='/loading.gif'></img>
                
              }
            </div>
          </ul>
        </div>
      </div>
    </div>
    </>
  );
}

export {  Home, bauMitigacionExterno, datosBauExterno, reduccionesExterno, bauReal,
          totalTTmateriaPrima, totalTTtrabajo, totalAereo, totalMaritimo, 
          totalEnergia, bauTotal, imgDona, dataPie, yearMeasure };